import React, { FC } from 'react';
import { Paper, Box, Button } from '@mui/material';
import { OrderEvent } from 'models/order-event';
import EventRecordTitle from 'components/shared/order-events-timeline/order-events/event-record-title.component';
import { eventOrganizationName } from 'components/shared/order-events-timeline/event-organization';
import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router-dom';

type EventOrderCreatedProps = {
    item: OrderEvent;
    isMultipleOrders: boolean;
};
const EventOrderCreated: FC<EventOrderCreatedProps> = ({ item, isMultipleOrders }: EventOrderCreatedProps) => {
    const orderDetailsUrl = `/order-details/${item.orderDbId}/main-view`;
    const { t: translate } = useTranslation(['order-event', 'common']);

    const eventTitle = () => {
        const userOrg = eventOrganizationName(item, translate('order-event:API_INTEGRATION'));
        return `${translate('NEW_ORDER_FROM')} ${userOrg}`;
    };

    const userFullName = () => {
        if (item.user) {
            return item.user.fullName;
        }
        return '';
    };

    return (
        <Paper variant="outlined">
            <Box p={2}>
                <EventRecordTitle
                    title={eventTitle()}
                    item={item}
                    color={item.color}
                    displayOrderLabel={isMultipleOrders}
                />
                <Box mt={1}>
                    {translate('common:DENTIST')}: {userFullName()}
                </Box>
                <ul>{item.lineItems?.map((action: string, index: number) => <li key={index}>{action}</li>)}</ul>
                {item.message ? (
                    <Box mt={2}>
                        {item.user && <em>{userFullName()}: </em>}
                        {item.message}
                    </Box>
                ) : undefined}
                {isMultipleOrders ? (
                    <Box display="flex" mt={1} alignItems="center">
                        <NavLink style={{ textDecoration: 'none' }} to={orderDetailsUrl}>
                            <Button variant="contained" sx={{ marginRight: 1 }}>
                                {translate('SHOW_ORDER')}
                            </Button>
                        </NavLink>
                    </Box>
                ) : undefined}
            </Box>
        </Paper>
    );
};

export default EventOrderCreated;
